<template>
  <div class="background">
    <div class="container">
      <br />
      <br />
      <br />
      <div class="changePasswordComponent shadow p-4">
        <h5 class="userEmail">mouadtaoussi@gmail.com</h5>
        <p>You could change your password right now</p>
        <!--<br />-->
        <div v-if="err" class="alert red text-white errMsg">{{ errMsg }}</div>
        <br />
        <input
          type="password"
          placeholder="Enter Your New Password"
          class="form-control password"
          name="password"
          v-model="password"
        />
        <br />
        <input
          type="password"
          placeholder="Confirm Your Password"
          class="form-control password"
          name="password"
          v-model="password2"
        />
        <br />
        <button
          @click="changePassword()"
          class="form-control changePassword send primary text-white btn"
        >
          Change Password
        </button>
        <br />
        <br />
      </div>
      <!-- Background Image Owner Account -->
      <!-- <p class="text-white owner-credit text-right">
        Photo by <a href="https://unsplash.com/@chuttersnap">chuttersnap</a> on
        <a href="https://unsplash.com/">Unsplash</a>
      </p>
    --></div>
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>

<script>
import footerApp from "../components/footer.vue";

// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");
export default {
  name: "changePassword",
  components: {
    footerApp
  },

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN

      id: this.$route.params.id,

      password: null,

      password2: null,

      errMsg: null,

      err: false
    };
  },
  created() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    // auth stuff goes here...
    if (this.token) {
      this.$router.push("/");
    }
    //Check id id valid
    this.$http
      .get(link.baselink + "/auth/isIdValid/" + this.id)
      .then(res => {
        if (res.data.isValid === false) {
          this.$router.push("/");
        }
      });
  },
  methods: {
    changePassword: function() {
      //alert('hello')
      document.querySelector(
        ".changePassword"
      ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-dark" role="status" aria-hidden="true"></span>
	        Please Wait...`;

      // Validate password
      if (this.password === null || this.password2 === null) {
        this.errMsg = "Please Fill The Inputs";
        this.err = true;

        // CHANGE BUTTON CONTENT BACK
        document.querySelector(".changePassword").innerHTML = `Change Password`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (this.password !== this.password2) {
        this.errMsg = "Your password and confirmation one doesn't matched!";
        this.err = true;

        // CHANGE BUTTON CONTENT BACK
        document.querySelector(".changePassword").innerHTML = `Change Password`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (this.password.length < 7) {
        this.errMsg = "Try to use a long password!";
        this.err = true;

        // CHANGE BUTTON CONTENT BACK
        document.querySelector(".changePassword").innerHTML = `Change Password`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else {
        //alert('hello');
        // Change password route
        this.$http({
          method: "post",
          url: link.baselink + "/auth/" + this.id,
          data: { new_password: this.password2 }
        })
          .then(res => {
            if (res.data.changed === true) {
              // STORE TOKEN IN THE LOCAL STORAGE
              window.localStorage.setItem("access-token", res.data.token);

              // RELOAD TO UPDATE HEADER
              window.location.reload();

              //REDIRECT THE USER TO THE DASHBOARD
              this.$router.push("/dashboard");
            }
          })
          .catch(() => {
            alert("Something Went Wrong! Try Again");
          });
        // Store token in local storage
        // Redirect to user dashboard

        // CHANGE BUTTON CONTENT BACK
        document.querySelector(".changePassword").innerHTML = `Change Password`;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.userEmail {
  color: var(--bg-color);
}
.background {
  /*background-image: url('.././assets/atul-vinayak-hZioHCEWSAE-unsplash.jpg'); /*Photo by Atul Vinayak on Unsplash  Mt Fuji */
  /*background-image: url(".././assets/chuttersnap-C4Lrq1F3vDQ-unsplash.jpg"); /*Photo by chuttersnap on Unsplash koalalampur city*/
  /* background-image: url('.././assets/owen-lystrup-boLgiM0qwkg-unsplash.jpg');*/ /*Photo by Owen Lystrup on Unsplash city in us */
  background-attachment: ;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
}
.owner-credit {
  margin-top: 12%;
}
.changePasswordComponent {
  border-radius: 3px;
  width: 40%;
  margin: 0 auto;
  background-color: white;
  position: relative;
  top: 30%;
  opacity: 0.9;
  transition: all 0.2s ease-out;
}
/*.loginComponent:hover {
  opacity: .9;
}*/
.suggestion {
  color: var(--bg-color);
  font-weight: 100;
  font-size: 12px;
  display: inline;
  padding: 3px;
}
.link {
  font-weight: 100;
  font-size: 12px;
  display: inline;
  padding: 3px;
}
input {
  font-size: 13px;
}
.red {
  background-color: var(--dan-ger);
}
.green {
  background-color: var(--succ-ess);
}
.primary {
  background-color: var(--primary-color);
}
.none {
  display: none;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.footerApp {
  margin-top: 100px;
}
@media only screen and (max-width: 600px) {
  .loginComponent {
    width: 100%;
  }
  .title {
    font-size: 30px !important;
  }
}
</style>
